import { useState } from "react";
import SumoAvailability from "../SumoCalendar/SumoAvailability";
import { SumoData } from "../SumoData";
import SumoGallery from "../SumoGallery";
import SumoMap from "../SumoMap";
import styles from "./SumoSection.module.scss";

interface SumoProps {
  data: SumoData;
}
export default function SumoSection({ data }: SumoProps) {
  const { tours, headerText, media, contentBlocks, mapTitle } = data;
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openSumoProducts, setOpenSumoProducts] = useState([]);

  return (
    <section
      style={{
        marginTop: 60,
      }}
    >
      <div className={styles.SumoHeadText}>
        <h2>{headerText.title}</h2>
        <p>{headerText.subTitle}</p>
      </div>
      <div className={styles.ContentBlocksContainer}>
        {contentBlocks.map((content, index) => {
          return (
            <div className={styles.ContentBlock} key={index}>
              <div className={styles.ContentBar}>
                <hr />
                <span>{content.barTitle}</span>
              </div>
              <div className={styles.ContentText}>
                <h3>{content.title}</h3>
                <p>{content.description}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.SumoGalleryCalendar}>
        <SumoGallery media={media} />

        <SumoAvailability
          ids={tours.map((t) => t.id)}
          openSumoProducts={openSumoProducts}
          setOpenSumoProducts={setOpenSumoProducts}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
        />
      </div>

      <div className={styles.SumoMapArea}>
        <h3>{mapTitle}</h3>
        {tours.length > 1 && (
          <div className={styles.ProductTabsContainer}>
            {tours.map((s, index) => {
              return (
                <div
                  key={index}
                  className={styles.Tab}
                  style={
                    selectedProduct === s.id
                      ? {
                          background: "#03bfa5",
                          color: "#fff",
                          fontWeight: "bold",
                        }
                      : !openSumoProducts.includes(s.id)
                      ? {
                          textDecoration: "line-through",
                          pointerEvents: "none",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (openSumoProducts.includes(s.id)) {
                      setSelectedProduct(s.id);
                    }
                  }}
                >
                  {openSumoProducts.includes(s.id) &&
                    selectedProduct !== s.id && (
                      <div
                        className={`${styles["AvailabilityCircle"]} ${styles["pulse"]}`}
                      />
                    )}{" "}
                  {s.tabName}
                </div>
              );
            })}
          </div>
        )}

        <SumoMap ids={tours.map((t) => t.id)} />
      </div>
    </section>
  );
}
